import script from "./DogForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DogForm.vue?vue&type=script&setup=true&lang=js"

import "./DogForm.vue?vue&type=style&index=0&id=3c1fcedf&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c1fcedf"]])

export default __exports__